import { datadogRum } from '@datadog/browser-rum';
//import type { GatsbyBrowser } from 'gatsby';
import DD_OPTIONS from '../common/scripts/data-dog-options';

if (datadogRum) {
  datadogRum.init(DD_OPTIONS);
  datadogRum.startSessionReplayRecording();
}
